import { render } from "./MovieDetail.vue?vue&type=template&id=246a5768"
import script from "./MovieDetail.vue?vue&type=script&lang=js"
export * from "./MovieDetail.vue?vue&type=script&lang=js"

import "./MovieDetail.vue?vue&type=style&index=0&id=246a5768&lang=scss"
script.render = render

export default script